export const navItem = [
  {
    href: '/dashboard',
    name: 'Dashboard',
  },
  {
    href: '/enhance-dispute',
    name: 'Enhanced Disputes',
  },
  {
    href: '/credit-builder',
    name: 'Credit Builder',
  },
  {
    href: '/credit-audit',
    name: 'Credit Audit',
  },
  {
    href: '/credit-report',
    name: 'Credit Report',
  },
  {
    href: '/dispute-center',
    name: 'Dispute Center',
  },
];
